import { iif, MonoTypeOperatorFunction, of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';

export const DEFAULT_TRIES = 20;
export const DEFAULT_DELAY = 500;

export function waitForIndex<T>(
    tries = DEFAULT_TRIES,
    delayInMilliseconds = DEFAULT_DELAY
): MonoTypeOperatorFunction<T> {
    return retryWhen(errors =>
        errors.pipe(
            concatMap((error, index) =>
                iif(() => index > tries, throwError(error), of(error).pipe(delay(delayInMilliseconds)))
            )
        )
    );
}
